import { processSteps } from "@/data/content";
import { Section, SectionHeading } from "./section";
import { CtaLink } from "./cta";
import { site } from "@/data/site";
import { track } from "@/lib/analytics";

export function ProcessTimeline() {
  return (
    <ol className="mt-12 grid gap-px overflow-hidden border border-hairline bg-hairline md:grid-cols-4">
      {processSteps.map((s) => (
        <li key={s.n} className="bg-background p-6 md:p-7">
          <span className="font-[family-name:var(--font-display)] text-3xl text-brass-ink">{s.n}</span>
          <h3 className="mt-4 text-base font-semibold">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}

export function FinalCTA({
  heading = "Have an idea in mind? Let's turn it into something meaningful.",
  body = "You do not need to know every material or technical detail. Tell Paul who the piece is for and what you are imagining, and he will help you explore the possibilities.",
  label = "Tell Paul What You Have in Mind",
}: {
  heading?: string;
  body?: string;
  label?: string;
}) {
  return (
    <Section tone="forest" labelledBy="final-cta-heading">
      <div className="shell">
        <div className="max-w-3xl">
          <SectionHeading
            id="final-cta-heading"
            eyebrow="Start a conversation"
            title={heading}
            lede={body}
            tone="light"
          />
          <div className="mt-9 flex flex-wrap gap-3">
            <CtaLink to="/design-your-piece" variant="brass" arrow className="h-12">
              {label}
            </CtaLink>
            <a
              href={`mailto:${site.email}`}
              onClick={() => track("click_email", { location: "final_cta" })}
              className="tap-safe inline-flex items-center justify-center rounded-sm border border-canvas/35 px-6 text-sm font-semibold text-canvas hover:bg-canvas/10 motion-craft transition-colors"
            >
              Email Paul directly
            </a>
          </div>
          <p className="mt-6 text-sm text-canvas/75">
            Prefer to talk it through?{" "}
            <a
              href={`tel:${site.phoneHref}`}
              onClick={() => track("click_phone", { location: "final_cta" })}
              className="text-brass-glow underline underline-offset-4"
            >
              {site.phoneDisplay}
            </a>
          </p>
        </div>
      </div>
    </Section>
  );
}
